/**
 * TODO
 * WIP
 */
import React from 'react';

import { css, cx } from '@emotion/css';
import { Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';
import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseSeparatorProps = {
  text?: string;
  className?: string;
};

type StyleClasses = {
  root: string;
  separator: string;
  content: string;
  text: string;
};

export type SeparatorProps = AtomProps<BaseSeparatorProps, StyleClasses>;

export const Separator: React.FC<SeparatorProps> = ({
  className,
  text,
  classes,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <div className={cx(styles.container, className, classes?.root)} {...props}>
      <div className={cx(styles.separator, classes?.separator)}></div>
      {text && (
        <span className={cx(styles.content, classes?.content)}>
          <span className={cx(styles.text, classes?.text)}>{text}</span>
        </span>
      )}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    width: 100%;
    height: ${theme.spacing(8)};
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    position: relative;
  `,
  separator: css`
    width: 100%;
    height: ${theme.spacing(1)};
    flex-shrink: 0;
    background: ${theme.palette.background.paper};
    position: absolute;
  `,
  content: css`
    display: inline-flex;
    height: ${theme.spacing(8)};
    padding: 0 ${theme.spacing(2)};
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing(4)};
    flex-shrink: 0;
    background: ${theme.palette.common.white};
    position: absolute;
    z-index: 2;
  `,
  text: css`
    text-transform: capitalize;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.2px;
  `,
});
